<template>
  <div class="edit-modal" v-if="showModal">
    <div class="modalHeader">
      <span class="title">View Questionnaire Field</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <div class="form-group">
        <label>Field ID:</label>
        <div class="fieldName">{{ fieldName }}</div>
        <button @click="editFormField" class="btn btn-sm btn-secondary btn-edit-field">Edit Form Field</button>
      </div>
      <div class="form-group">
        <label for="fieldTitle">Field Title</label>
        <input disabled type="text" class="form-control form-control-sm" id="fieldTitle" v-model="fieldTitle">
      </div>
      <div class="form-group">
        <label for="helpText">Inline Help Text</label>
        <textarea disabled class="form-control form-control-sm" id="helpText" v-model="fieldDesc"></textarea>
      </div>
      <div class="form-group">
        <label for="model">Model</label>
        <textarea disabled class="form-control form-control-sm" id="model" v-model="fieldModel" />
      </div>
      <div class="button-box float-right">
        <button class="btn btn-secondary" @click="closeModal">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'edit-modal',

  mounted () {
    let that = this
    this.$on('showModal', function (fieldData) {
      that.key = fieldData.key
      that.field = fieldData.data
      that.fieldTitle = that.field.title
      that.fieldDesc = that.field.desc
      that.fieldModel = that.field.model
      that.fieldName = that.field.fieldDisplayName
      that.showModal = true
    })

    this.$on('widgetChanged', function (data) {
      that.widgetChanged(data)
    })

    document.addEventListener('keyup', this.keyCheck)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.keyCheck, false)

    this.$off('showModal')
    this.$off('widgetChanged')
  },

  data () {
    return {
      key: '',
      showModal: false,
      fieldTitle: '',
      fieldDesc: '',
      fieldModel: '',
      fieldName: '',
      field: {}
    }
  },

  methods: {
    keyCheck (evt) {
      if (evt.keyCode === 27) this.closeModal()
    },

    widgetChanged (data) {
      console.log(data)
      this.field.newValue = data.value
    },

    editFormField () {
      this.showModal = false
      this.$bus.emit('openFieldMenu', {
        id: this.field.fieldName,
        page: this.field.page
      })
    },

    saveField () {
      this.field.title = this.fieldTitle
      this.field.name = this.fieldName
      this.field.desc = this.fieldDesc
      this.field.model = this.fieldModel
      this.$parent.$emit('saveEdit', {
        key: this.key,
        data: this.field
      })
      this.showModal = false
    },

    closeModal () {
      this.showModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .widget {
    display: inline;
  }

  .widget-input {
    margin-bottom: 30px;
  }

  .widget-label {
    font-weight: bold;
  }

  .edit-modal {
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    height: 460px;
    max-width: 1700px;
    min-height: 200px;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;
    overflow: hidden;

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .modalBody {
      position: absolute;
      padding: 10px;
      width: 100%;
      height: calc(100% - 37px);
      overflow-y: auto;
    }
  }

  .fieldName {
    display: inline;
  }

  .btn-edit-field {
    display: block;
    margin-top: 5px;
    font-size: 10px;
    transition: .3s;
    &:hover {
      background-color: #333;
      color: white;
      transition: .3s;
    }
  }

  .button-box {
    float: right;
    margin-right: 30px;
    .btn {
      margin-left: 10px;
    }
  }

  .input-subtext {
    color: #777;
  }

  @media only screen and (max-device-width : 680px) {
    .edit-modal {
      top: 0;
      left: 0;
      margin-left: 0;
      width: 100%;
      min-height: 100%;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/questionnaires/EditModal.vue